export default "__VITE_ASSET__B4t2D4ek__"